import { Pipe, PipeTransform } from '@angular/core';
import { ReviewTargetModel } from '@models/reviewTarget.model';

@Pipe({
  name: 'zillowCallActionUrlSuffix'
})
export class ZillowCallActionUrlSuffix implements PipeTransform{

  transform(reviewTarget: ReviewTargetModel): string {
    return (reviewTarget.callActionUrl
      ? reviewTarget.callActionUrl.split('?s=')[1] || ''
      : ''
    ).trim();
  }

}
